export default __webpack_public_path__ + "static/media/556.ef1eb335.png";